import { parseDate } from './FilterModal';

const isBlank = (v) => v === undefined || v === null || v === '';

const toDate = (value, dateFormat) => {
  if (isBlank(value)) return null;
  try {
    const d = dateFormat ? parseDate(String(value), dateFormat) : new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
  } catch (error) {
    return null;
  }
};

const text = (v) => (isBlank(v) ? '' : String(v).toLowerCase());

const matchers = {
  contains: (cell, value) => text(cell).includes(text(value)),
  exact: (cell, value) => text(cell) === text(value),
  equal: (cell, value) => text(cell) === text(value),
  greater_than: (cell, value) => Number(cell) > Number(value),
  less_than: (cell, value) => Number(cell) < Number(value),
  is: (cell, value) => String(cell) === String(value),
};

// Dates in the table are shown in the user's format, filter values are ISO.
const dateMatchers = {
  before: (cell, start) => cell < start,
  after: (cell, start) => cell > start,
  on: (cell, start) => cell.toDateString() === start.toDateString(),
  range: (cell, start, end) =>
    (!start || cell >= start) && (!end || cell <= end),
};

const matchesValue = (filter, cell, start, end, dateFormat) => {
  if (filter.columnType === 'date') {
    const matcher = dateMatchers[filter.condition];
    const cellDate = toDate(cell, dateFormat);
    const startDate = toDate(start);
    const endDate = toDate(end);
    if (!matcher || !cellDate || !(startDate || endDate)) return false;
    return matcher(cellDate, startDate, endDate);
  }

  if (filter.condition === 'range') {
    const c = text(cell);
    return (isBlank(start) || c >= text(start)) && (isBlank(end) || c <= text(end));
  }
  const matcher = matchers[filter.condition];
  return matcher ? matcher(cell, start) : true;
};

/**
 * Filters table rows in the browser. Rows must be keyed by the column id.
 * A filter that is incomplete (no column, condition or value) is ignored, all
 * the others must match (AND). Extra value fields of one filter are OR-ed.
 */
const applyClientFilters = (filters, data = [], dateFormat) => {
  if (!Array.isArray(filters)) return data;

  const active = filters.filter((f) => {
    if (!f.column || !f.condition) return false;
    const extra = f.additionalValues || { start: [], end: [] };
    return [f.value, f.endValue, ...extra.start, ...extra.end].some((v) => !isBlank(v));
  });
  if (active.length === 0) return data;

  return data.filter((row) =>
    active.every((filter) => {
      const extra = filter.additionalValues || { start: [], end: [] };
      const starts = [filter.value, ...extra.start];
      const ends = [filter.endValue, ...extra.end];
      return starts.some((start, i) => {
        const end = ends[i];
        if (isBlank(start) && isBlank(end)) return false;
        return matchesValue(filter, row[filter.column], start, end, dateFormat);
      });
    }),
  );
};

export default applyClientFilters;
